import React, { useContext } from 'react';
import { FormContext } from '../FormContext.jsx';
import { isAdminApp } from '../../../public/lib/PageHelpers.js';
import QuestionLabel from './QuestionLabel';
import EmailInput from '../../EmailInput.jsx';
import ShowPackageBalance from '~/components/forms/questions/components/ShowPackageBalance.jsx';
import { FEATURE_MARKETING } from '~/lib/Features.js';
import { FormPart, part } from '~/lib/FormCssApi';

const SingleGuest = ({ value, setValue, settings, labelPrefix, idx, formContext, isLast }) => {
    const labelSuffix = idx > 0 ? idx + 1 : '';
    const isFirst = idx === 0;
    const effectiveSettings = !isFirst
        ? settings
        : { ...settings, required: true /*always requried!*/ };

    const isMarketingEnabled = formContext?.features?.[FEATURE_MARKETING] || false;

    return (
        <div {...part(FormPart.CONTROL)} className="mb-4">
            <QuestionLabel
                label={`${labelPrefix} Name ${labelSuffix}`}
                settings={effectiveSettings}
            />
            <input
                {...part(FormPart.INPUT)}
                type="text"
                placeholder=""
                className="mr-4"
                value={value?.name || ''}
                autoComplete="name"
                name={`client-${idx}-name`}
                onChange={e => setValue({ ...value, name: e.target.value })}
            />

            <QuestionLabel
                label={`${labelPrefix} Email ${labelSuffix}`}
                settings={effectiveSettings}
                className="mt-4"
            />
            <EmailInput
                {...part(FormPart.INPUT)}
                value={value?.email || ''}
                name={`client-${idx}-email`}
                onChange={newValue => setValue({ ...value, email: newValue })}
            />
            {isFirst && isMarketingEnabled && !isAdminApp() && (
                <label className="flex items-center mt-2">
                    <input
                        type="checkbox"
                        className="mr-2"
                        checked={value?.marketingOptIn || false}
                        onChange={e => setValue({ ...value, marketingOptIn: e.target.checked })}
                    />
                    <span className="text-sm text-gray-700">
                        I would like to receive marketing communications
                    </span>
                </label>
            )}
            {isFirst && (
                <ShowPackageBalance
                    settings={settings}
                    email={value?.email}
                    name={value?.name}
                />
            )}
            {!isLast && <hr className="mt-4" />}
        </div>
    );
};

const ContactInfoQuestion = ({ label, value, setValue, settings }) => {
    const formContext = useContext(FormContext);

    // Default to 0 guests, or 1 if it's the admin app so we show some preview
    const contactQuantity = !!settings.disableGuestEntry
        ? 1
        : formContext?.eventQuantity || 1;

    value = value || [];

    return (
        <div>
            {[...Array(contactQuantity)].map((num, idx) => (
                <SingleGuest
                    key={idx}
                    labelPrefix={settings?.labelPrefix || ''}
                    idx={idx}
                    isLast={idx === contactQuantity - 1}
                    settings={settings}
                    formContext={formContext}
                    value={value[idx] || {}}
                    setValue={newSingleValue => {
                        const newValue = [...value];
                        newValue[idx] = newSingleValue;
                        setValue(newValue);
                    }}
                />
            ))}
        </div>
    );
};

export default ContactInfoQuestion;
